import { components } from '../.generated';
import { OneService } from '../OneService';

type Scope = 'tenant' | 'deviceRegister';

type ListKeyVaultResult =
  | components['schemas']['ListTenantKeyVaultQueryResult']
  | components['schemas']['ListDeviceRegisterKeyVaultQueryResult'];
type GetKeyVaultResult =
  | components['schemas']['GetTenantKeyVaultQueryResult']
  | components['schemas']['GetDeviceRegisterKeyVaultQueryResult'];
type CreateKeyVaultResult =
  | components['schemas']['CreateTenantKeyVaultCommandResult']
  | components['schemas']['CreateDeviceRegisterKeyVaultCommandResult'];
type RevokeKeyVaultResult =
  | components['schemas']['RevokeTenantKeyVaultCommandResult']
  | components['schemas']['RevokeDeviceRegisterKeyVaultCommandResult'];

export class KeyVaultApi {
  private one: OneService;

  constructor(one: OneService) {
    this.one = one;
  }

  /* ---------------- LIST ---------------- */

  async list(scope: Scope, params: any) {
    return this.one.query<ListKeyVaultResult>({
      query: {
        type:
          scope === 'tenant'
            ? 'ListTenantKeyVaultQuery'
            : 'ListDeviceRegisterKeyVaultQuery',
        ...params,
      },
    });
  }

  /* ---------------- GET ---------------- */

  async get(scope: Scope, params: any) {
    return this.one.query<GetKeyVaultResult>({
      query: {
        type:
          scope === 'tenant'
            ? 'GetTenantKeyVaultQuery'
            : 'GetDeviceRegisterKeyVaultQuery',
        ...params,
      },
    });
  }

  /* ---------------- CREATE ---------------- */

  async create(scope: Scope, payload: any) {
    return this.one.command<CreateKeyVaultResult>({
      command: {
        type:
          scope === 'tenant'
            ? 'CreateTenantKeyVaultCommand'
            : 'CreateDeviceRegisterKeyVaultCommand',
        ...payload,
      },
    });
  }

  /* ---------------- REVOKE ---------------- */

  async revoke(scope: Scope, payload: any) {
    return this.one.command<RevokeKeyVaultResult>({
      command: {
        type:
          scope === 'tenant'
            ? 'RevokeTenantKeyVaultCommand'
            : 'RevokeDeviceRegisterKeyVaultCommand',
        ...payload,
      },
    });
  }
}
